import { NO, YES } from '../../applicantStore/types/YesOrNo';
import useApplicantStore from '../../applicantStore/useApplicantStore';
import useCoapplicantStore from '../../coapplicantStore/useCoapplicantStore';
import useDashboardStore from '../../dashboardStore/useDashboardStore';
import { WorkflowPage } from '../types/WorkflowPage';

export const applicantWorkflow: WorkflowPage[] = [
  {
    get path() {
      const {
        computed: { vehicleId },
      } = useDashboardStore.getState();
      return `/applicant/${vehicleId}`;
    },
  },
  {
    completed() {
      const { currentResidenceType } = useApplicantStore.getState();

      return Boolean(currentResidenceType);
    },
    get path() {
      const {
        computed: { vehicleId },
      } = useDashboardStore.getState();
      return `/applicant/${vehicleId}/residence-type`;
    },
  },
  {
    completed() {
      const {
        computed: { isCurrentResidenceDetailsCompleted },
      } = useApplicantStore.getState();

      return isCurrentResidenceDetailsCompleted;
    },
    get path() {
      const {
        computed: { vehicleId },
      } = useDashboardStore.getState();
      return `/applicant/${vehicleId}/residence-details`;
    },
  },
  {
    get path() {
      const {
        computed: { vehicleId },
      } = useDashboardStore.getState();
      return `/applicant/${vehicleId}/residence-duration`;
    },
  },
  {
    condition() {
      const {
        computed: { isCurrentResidenceLessThan2Years },
      } = useApplicantStore.getState();

      return isCurrentResidenceLessThan2Years;
    },
    get path() {
      const {
        computed: { vehicleId },
      } = useDashboardStore.getState();
      return `/applicant/${vehicleId}/previous-residence`;
    },
  },
  {
    completed() {
      const { isCurrentlyEmployed } = useApplicantStore.getState();

      return Boolean(isCurrentlyEmployed);
    },
    get path() {
      const {
        computed: { vehicleId },
      } = useDashboardStore.getState();
      return `/applicant/${vehicleId}/employment-status`;
    },
  },
  {
    completed() {
      const { isCurrentlyEmployed, currentIncomeEmploymentType } =
        useApplicantStore.getState();

      // Only check completion if this page is actually in the workflow path
      // Page is not applicable, so consider it "completed"
      if (isCurrentlyEmployed !== YES) {
        return true;
      }

      return Boolean(currentIncomeEmploymentType);
    },
    condition() {
      const { isCurrentlyEmployed } = useApplicantStore.getState();
      return isCurrentlyEmployed === YES;
    },
    get path() {
      const {
        computed: { vehicleId },
      } = useDashboardStore.getState();
      return `/applicant/${vehicleId}/employment-type`;
    },
  },
  {
    completed() {
      const { isCurrentlyEmployed, currentIncomeEmploymentType } =
        useApplicantStore.getState();

      // Only check completion if this page is actually in the workflow path
      // Page is not applicable, so consider it "completed"
      if (isCurrentlyEmployed !== NO) {
        return true;
      }

      return Boolean(currentIncomeEmploymentType);
    },
    condition() {
      const { isCurrentlyEmployed } = useApplicantStore.getState();
      return isCurrentlyEmployed === NO;
    },
    get path() {
      const {
        computed: { vehicleId },
      } = useDashboardStore.getState();
      return `/applicant/${vehicleId}/unemployment-type`;
    },
  },
  {
    completed() {
      const {
        isCurrentlyEmployed,
        computed: { isCurrentIncomeEmployedDetailsCompleted },
      } = useApplicantStore.getState();

      // Only check completion if this page is actually in the workflow path
      // Page is not applicable, so consider it "completed"
      if (isCurrentlyEmployed !== YES) {
        return true;
      }

      return isCurrentIncomeEmployedDetailsCompleted;
    },
    condition() {
      const { isCurrentlyEmployed } = useApplicantStore.getState();
      return isCurrentlyEmployed === YES;
    },
    get path() {
      const {
        computed: { vehicleId },
      } = useDashboardStore.getState();
      return `/applicant/${vehicleId}/employment-details`;
    },
  },
  {
    completed() {
      const {
        isCurrentlyEmployed,
        computed: { isCurrentIncomeUnemployedDetailsCompleted },
      } = useApplicantStore.getState();

      // Only check completion if this page is actually in the workflow path
      // Page is not applicable, so consider it "completed"
      if (isCurrentlyEmployed !== NO) {
        return true;
      }

      return isCurrentIncomeUnemployedDetailsCompleted;
    },
    condition() {
      const { isCurrentlyEmployed } = useApplicantStore.getState();
      return isCurrentlyEmployed === NO;
    },
    get path() {
      const {
        computed: { vehicleId },
      } = useDashboardStore.getState();
      return `/applicant/${vehicleId}/unemployment-details`;
    },
  },
  {
    get path() {
      const {
        computed: { vehicleId },
      } = useDashboardStore.getState();
      return `/applicant/${vehicleId}/employment-duration`;
    },
  },
  {
    condition() {
      const {
        computed: { isCurrentIncomeLessThan1Year },
      } = useApplicantStore.getState();

      return isCurrentIncomeLessThan1Year;
    },
    get path() {
      const {
        computed: { vehicleId },
      } = useDashboardStore.getState();
      return `/applicant/${vehicleId}/previous-employment`;
    },
  },
  {
    get path() {
      const {
        computed: { vehicleId },
      } = useDashboardStore.getState();
      return `/applicant/${vehicleId}/additional-income`;
    },
  },
  {
    condition() {
      const { hasAdditionalIncome } = useApplicantStore.getState();
      return hasAdditionalIncome === YES;
    },
    get path() {
      const {
        computed: { vehicleId },
      } = useDashboardStore.getState();
      return `/applicant/${vehicleId}/income-details`;
    },
  },
  {
    get path() {
      const {
        computed: { vehicleId },
      } = useDashboardStore.getState();
      return `/applicant/${vehicleId}/add-coapplicant`;
    },
  },
  {
    condition() {
      const { addCoapplicant } = useApplicantStore.getState();
      return addCoapplicant === YES;
    },
    get path() {
      const {
        computed: { vehicleId },
      } = useDashboardStore.getState();
      return `/applicant/${vehicleId}/coapp-personal-relationship`;
    },
  },
  {
    condition() {
      const { addCoapplicant } = useApplicantStore.getState();
      return addCoapplicant === YES;
    },
    get path() {
      const {
        computed: { vehicleId },
      } = useDashboardStore.getState();
      return `/applicant/${vehicleId}/coapp-personal-details`;
    },
  },
  {
    condition() {
      const { addCoapplicant } = useApplicantStore.getState();
      return addCoapplicant === YES;
    },
    get path() {
      const {
        computed: { vehicleId },
      } = useDashboardStore.getState();
      return `/applicant/${vehicleId}/coapp-residence-relationship`;
    },
  },
  {
    condition() {
      const { addCoapplicant } = useApplicantStore.getState();
      const { hasSameResidenceAsApplicant } = useCoapplicantStore.getState();
      return addCoapplicant === YES && hasSameResidenceAsApplicant === YES;
    },
    get path() {
      const {
        computed: { vehicleId },
      } = useDashboardStore.getState();
      return `/applicant/${vehicleId}/coapp-same-residence`;
    },
  },
  {
    condition() {
      const { addCoapplicant } = useApplicantStore.getState();
      const { hasSameResidenceAsApplicant } = useCoapplicantStore.getState();
      return addCoapplicant === YES && hasSameResidenceAsApplicant === NO;
    },
    get path() {
      const {
        computed: { vehicleId },
      } = useDashboardStore.getState();
      return `/applicant/${vehicleId}/coapp-different-residence-type`;
    },
  },
  {
    condition() {
      const { addCoapplicant } = useApplicantStore.getState();
      const { hasSameResidenceAsApplicant } = useCoapplicantStore.getState();
      return addCoapplicant === YES && hasSameResidenceAsApplicant === NO;
    },
    get path() {
      const {
        computed: { vehicleId },
      } = useDashboardStore.getState();
      return `/applicant/${vehicleId}/coapp-different-residence`;
    },
  },
  {
    condition() {
      const { addCoapplicant } = useApplicantStore.getState();
      return addCoapplicant === YES;
    },
    get path() {
      const {
        computed: { vehicleId },
      } = useDashboardStore.getState();
      return `/applicant/${vehicleId}/coapp-residence-duration`;
    },
  },
  {
    condition() {
      const { addCoapplicant } = useApplicantStore.getState();
      const {
        computed: { isCurrentResidenceLessThan2Years },
      } = useCoapplicantStore.getState();

      return addCoapplicant === YES && isCurrentResidenceLessThan2Years;
    },
    get path() {
      const {
        computed: { vehicleId },
      } = useDashboardStore.getState();
      return `/applicant/${vehicleId}/coapp-previous-residence`;
    },
  },
  {
    condition() {
      const { addCoapplicant } = useApplicantStore.getState();
      return addCoapplicant === YES;
    },
    get path() {
      const {
        computed: { vehicleId },
      } = useDashboardStore.getState();
      return `/applicant/${vehicleId}/coapp-employment-status`;
    },
  },
  {
    condition() {
      const { addCoapplicant } = useApplicantStore.getState();
      const { isCoapplicantCurrentlyEmployed } = useCoapplicantStore.getState();
      return addCoapplicant === YES && isCoapplicantCurrentlyEmployed === YES;
    },
    get path() {
      const {
        computed: { vehicleId },
      } = useDashboardStore.getState();
      return `/applicant/${vehicleId}/coapp-employment-type`;
    },
  },
  {
    condition() {
      const { addCoapplicant } = useApplicantStore.getState();
      const { isCoapplicantCurrentlyEmployed } = useCoapplicantStore.getState();
      return addCoapplicant === YES && isCoapplicantCurrentlyEmployed === NO;
    },
    get path() {
      const {
        computed: { vehicleId },
      } = useDashboardStore.getState();
      return `/applicant/${vehicleId}/coapp-unemployment-type`;
    },
  },
  {
    condition() {
      const { addCoapplicant } = useApplicantStore.getState();
      const { isCoapplicantCurrentlyEmployed } = useCoapplicantStore.getState();
      return addCoapplicant === YES && isCoapplicantCurrentlyEmployed === YES;
    },
    get path() {
      const {
        computed: { vehicleId },
      } = useDashboardStore.getState();
      return `/applicant/${vehicleId}/coapp-employment-details`;
    },
  },
  {
    condition() {
      const { addCoapplicant } = useApplicantStore.getState();
      const { isCoapplicantCurrentlyEmployed } = useCoapplicantStore.getState();
      return addCoapplicant === YES && isCoapplicantCurrentlyEmployed === NO;
    },
    get path() {
      const {
        computed: { vehicleId },
      } = useDashboardStore.getState();
      return `/applicant/${vehicleId}/coapp-unemployment-details`;
    },
  },
  {
    condition() {
      const { addCoapplicant } = useApplicantStore.getState();
      return addCoapplicant === YES;
    },
    get path() {
      const {
        computed: { vehicleId },
      } = useDashboardStore.getState();
      return `/applicant/${vehicleId}/coapp-employment-duration`;
    },
  },
  {
    condition() {
      const { addCoapplicant } = useApplicantStore.getState();
      const {
        computed: { isCurrentIncomeLessThan1Year },
      } = useCoapplicantStore.getState();

      return addCoapplicant === YES && isCurrentIncomeLessThan1Year;
    },
    get path() {
      const {
        computed: { vehicleId },
      } = useDashboardStore.getState();
      return `/applicant/${vehicleId}/coapp-previous-employment`;
    },
  },
  {
    condition() {
      const { addCoapplicant } = useApplicantStore.getState();
      return addCoapplicant === YES;
    },
    get path() {
      const {
        computed: { vehicleId },
      } = useDashboardStore.getState();
      return `/applicant/${vehicleId}/coapp-additional-income`;
    },
  },
  {
    condition() {
      const { hasAdditionalIncome } = useCoapplicantStore.getState();
      const { addCoapplicant } = useApplicantStore.getState();
      return addCoapplicant === YES && hasAdditionalIncome === YES;
    },
    get path() {
      const {
        computed: { vehicleId },
      } = useDashboardStore.getState();
      return `/applicant/${vehicleId}/coapp-income-details`;
    },
  },
  {
    get path() {
      const {
        computed: { vehicleId },
      } = useDashboardStore.getState();
      return `/applicant/${vehicleId}/review-applicant`;
    },
  },
  {
    condition() {
      const { addCoapplicant } = useApplicantStore.getState();
      return addCoapplicant === YES;
    },
    get path() {
      const {
        computed: { vehicleId },
      } = useDashboardStore.getState();
      return `/applicant/${vehicleId}/coapp-review-applicant`;
    },
  },
  {
    get path() {
      const {
        computed: { vehicleId },
      } = useDashboardStore.getState();
      return `/applicant/${vehicleId}/submit-application`;
    },
  },
  {
    get path() {
      const {
        computed: { vehicleId },
      } = useDashboardStore.getState();
      return `/applicant/${vehicleId}/application-success`;
    },
  },
];
